(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
/* ATTIFIT: section-scoped recommendations loader. The stock loader used
   document.querySelector('.related-products') - first match only - which
   breaks with multiple instances and, in the theme editor, always reloaded
   the first instance regardless of which section was edited. This version
   loads each instance from its own data-url ([data-url] also keeps it from
   ever matching the cart drawer's .related-products markup), checks
   response.ok, guards against overlapping loads per instance, and binds its
   listeners exactly once. */
(function() {
  var loadRecommendations = function(sectionRoot) {
    if (!sectionRoot || !sectionRoot.dataset.url) { return; }
    if (sectionRoot.dataset.attifitRecsLoading === 'true') { return; }
    sectionRoot.dataset.attifitRecsLoading = 'true';
    fetch(sectionRoot.dataset.url)
      .then(function(response) {
        if (!response.ok) { throw new Error('HTTP error! Status: ' + response.status); }
        return response.text();
      })
      .then(function(html) {
        var container = document.createElement('template');
        container.innerHTML = html;
        var fresh = container.content.querySelector('.related-products[data-section-id="' + sectionRoot.dataset.sectionId + '"]');
        if (fresh && sectionRoot.isConnected) {
          sectionRoot.innerHTML = fresh.innerHTML;
        }
      })
      .catch(function(error) {
        console.warn(error);
      })
      .finally(function() {
        delete sectionRoot.dataset.attifitRecsLoading;
      });
  };

  document.querySelectorAll('.related-products[data-url]').forEach(loadRecommendations);

  // Theme editor: reload only the instance(s) inside the reloaded section.
  document.addEventListener('shopify:section:load', function(event) {
    if (!event.target || !event.target.querySelectorAll) { return; }
    event.target.querySelectorAll('.related-products[data-url]').forEach(loadRecommendations);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
